import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ShoppingCartItem} from '@app/service/shopping-cart.service';

@Component({
	selector: 'app-shopping-cart-item',
	templateUrl: './shopping-cart-item.component.html',
	styleUrls: ['./shopping-cart-item.component.scss']
})
export class ShoppingCartItemComponent {
	@Output() removeItem = new EventEmitter<ShoppingCartItem>();
	@Output() updateItem = new EventEmitter();
	@Input() item!: ShoppingCartItem;
}
